import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Modal, Spin } from "antd";
import React, { Component } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "../styles/style.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default class ModalViewCer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      loading: true,
      numPages: "",
      pageShow: 1,
      zoom: 1,
      copydone: false,
    };
    this.copyinput = React.createRef();
  }

  close = () => {
    this.setState({
      isOpen: false,
      loading: true,
    });
  };

  open = () => {
    this.setState({
      isOpen: true,
    });
  };

  hideSpinner = () => {
    this.setState({
      loading: false,
    });
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({
      loading: true,
    });
    if (numPages > 1) {
      this.setState({
        numPages,
      });
    }
  };

  setPageShow = (type) => {
    var { pageShow } = this.state;
    switch (type) {
      case 1:
        this.setState({ pageShow: pageShow - 1 });
        break;
      case 2:
        this.setState({ pageShow: pageShow + 1 });
        break;
    }
  };

  pickZoom = (v) => {
    this.setState({ zoom: v });
  };

  downloadFile = (evt) => {
    // helper._downloadPdf(this.props.url);
  };

  copy = () => {
    this.setState({ copydone: true });
    // helper.copyClipboardRef(this.copyinput);
    setTimeout(() => {
      this.setState({ copydone: false });
    }, 2000);
  };

  render() {
    const css = {
      conmodal: {
        position: "fixed",
        zIndex: 1300,
        inset: "0px",
      },
      containerbody: {
        outline: 0,
        padding: 0,
        borderRadius: 5,
      },
      zoom: {
        border: "1px solid white",
        padding: "2px 5px",
        borderRadius: 10,
        textAlign: "center",
        margin: "0px 5px",
      },
    };
    var url = this.props.url;

    return (
      <Modal
        open={this.props.isOpen}
        onCancel={() => {
          this.props.onClose();
          this.setState({
            pageShow: 1,
          });
        }}
        style={css.conmodal}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        footer={false}
        className="pdf-modal"
      >
        <div style={css.containerbody}>
          <div
            style={{ height: "calc(100vh - 16px)", backgroundColor: "white" }}
          >
            <div
              style={{
                textAlign: "right",
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background:
                  "linear-gradient(93deg, #009B4B 2.42%, #00A79D 97.58%)",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "white",
                  fontSize: 16,
                }}
              >
                {this.props.title}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 40,
                }}
              ></div>
            </div>
            <div>
              <Document
                file={url}
                onLoadSuccess={this.onDocumentLoadSuccess}
                onLoadError={console.error}
                loading={<Spin />}
                renderMode={"canvas"}
                // rotate={90}
              >
                <div
                  style={{
                    height: window.innerHeight.valueOf() - 135,
                    width: window.innerWidth.valueOf() - 16,
                    overflow: "scroll",
                  }}
                >
                  <Page
                    width={(window.innerWidth.valueOf() - 16) * this.state.zoom}
                    // height={
                    //   (window.innerHeight.valueOf() - 135) * this.state.zoom
                    // }
                    pageNumber={this.state.pageShow}
                  />
                </div>
              </Document>
              {this.state.loading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    height: 50,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    position: "fixed",
                    bottom: 8,
                    width: "calc(100% - 16px)",
                    color: "white",
                  }}
                >
                  {this.state.numPages > 1 && (
                    <div
                      style={{
                        width: "50%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          paddingLeft: 10,
                        }}
                      >
                        {this.state.pageShow !== 1 && (
                          <LeftOutlined onClick={() => this.setPageShow(1)} />
                        )}
                        <span style={{ padding: "0px 10px" }}>
                          Trang {this.state.pageShow} của {this.state.numPages}
                        </span>
                        {this.state.pageShow !== this.state.numPages && (
                          <RightOutlined onClick={() => this.setPageShow(2)} />
                        )}
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <div>Phóng to</div>
                    <div>
                      <span
                        style={{
                          ...css.zoom,
                          backgroundColor: this.state.zoom === 1 ? "white" : "",
                          color: this.state.zoom === 1 ? "blue" : "white",
                        }}
                        onClick={() => this.pickZoom(1)}
                      >
                        1x
                      </span>
                      <span
                        style={{
                          ...css.zoom,
                          backgroundColor: this.state.zoom === 2 ? "white" : "",
                          color: this.state.zoom === 2 ? "blue" : "white",
                        }}
                        onClick={() => this.pickZoom(2)}
                      >
                        2x
                      </span>
                      <span
                        style={{
                          ...css.zoom,
                          backgroundColor: this.state.zoom === 3 ? "white" : "",
                          color: this.state.zoom === 3 ? "blue" : "white",
                        }}
                        onClick={() => this.pickZoom(3)}
                      >
                        3x
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
